export default [
  {
    path: '/newsroom',
    name: 'PressReleaseView',
    component: () =>
      import(
        /* webpackChunkName: "skyplay" */ '@/views/SKYPlay/PressReleaseView.vue'
      ),
    meta: { title: 'Press Release', group: 'skyplay' },
  },
  {
    path: '/notice_list',
    name: 'GameNoticeView',
    component: () =>
      import(
        /* webpackChunkName: "skyplay" */ '@/views/SKYPlay/GameNoticeView.vue'
      ),
    meta: { title: 'Game Notice', group: 'skyplay' },
  },
  {
    path: '/file_list',
    name: 'TUSUploadListView',
    component: () =>
      import(
        /* webpackChunkName: "skyplay" */ '@/views/SKYPlay/TUSUploadListView.vue'
      ),
    meta: { title: 'File List', group: 'skyplay' },
  },
]
